import React, { useState, useEffect } from 'react';
// import { useDispatch } from 'react-redux';
import {
  AppBar,
  Toolbar,
  IconButton,
  Box,
  Menu,
  MenuItem,
  Typography,

  // SelectChangeEvent,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
//import { useNavigate } from 'react-router-dom';
import SideBar from './SideBar';
import { AccountCircle } from '@mui/icons-material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { EditProfileForm, ChangePasswordForm } from './ProfileForms';
import { useNavigate } from 'react-router-dom';
import {clearUserData } from '../../context/PermissionContext';
import NotificationBell from './NotificationBell';
// import { logout } from '../store/actions/authActions'

interface NavBarProps {
  onDrawerToggle: () => void;
}

const NavBar: React.FC<NavBarProps> = ({ onDrawerToggle }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  // const [language, setLanguage] = useState('en');
  const navigate = useNavigate();
  //   const dispatch = useDispatch();
  const [displayName, setDisplayName] = useState<string>('');

  const loadUserDisplayName = () => {
    try {
      const raw = localStorage.getItem('userData');
      if (!raw) {
        setDisplayName('');
        return;
      }
      const data = JSON.parse(raw);
      const name = data?.userDetails?.name || data?.userDetails?.fullName || data?.name || data?.email || '';
      setDisplayName(name);
    } catch {
      setDisplayName('');
    }
  };

  useEffect(() => {
    loadUserDisplayName();

    const handleUserDataChanged = () => loadUserDisplayName();
    window.addEventListener('userDataChanged', handleUserDataChanged);
    window.addEventListener('storage', handleUserDataChanged);

    return () => {
      window.removeEventListener('userDataChanged', handleUserDataChanged);
      window.removeEventListener('storage', handleUserDataChanged);
    };
  }, []);

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // const handleLanguageChange = (event: SelectChangeEvent) => {
  //   setLanguage(event.target.value);
  // };

  const handleLogout = () => {
    
    navigate('/');
    localStorage.setItem('userid', JSON.stringify(null));
    localStorage.setItem('userId', JSON.stringify(null));
    localStorage.setItem('token', JSON.stringify(null));
    localStorage.setItem('itemSubCategoryId', JSON.stringify(null));
    localStorage.removeItem('authToken');
    localStorage.removeItem('userId');
    localStorage.removeItem('userid');
    localStorage.removeItem('token');
    localStorage.removeItem('itemSubCategoryId');
    
    // Clear userData and trigger permission refresh
    clearUserData();
    
    // dispatch(logout());
    
  };

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const [passwordOpen, setPasswordOpen] = useState(false);

  const toggleDrawer = (open: boolean) => () => {
    setDrawerOpen(open);
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor: 'white',
        color: '#333',
        boxShadow: 'none',
        borderBottom: '1px solid #eee',
      }}
    >
      <Toolbar>
        <IconButton
          edge="start"
          color="inherit"
          aria-label="menu"
          onClick={onDrawerToggle}
          sx={{ mr: 2 }}
        >
          <MenuIcon />
        </IconButton>

        {/* Logo */}
        <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
          <img
            src="/logo.png"
            alt="ShopUp Food"
            style={{ height: '40px', marginRight: '10px', objectFit: 'contain',
                  filter: 'brightness(0) invert(0)' }}
          />
          <Typography variant="h6" sx={{ fontWeight: 600, color: '#333' }}>
            Foodigo Admin
          </Typography>
        </Box>

        {/* Right side items */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          {/* Language selector */}
          {/* <FormControl size="small" sx={{ minWidth: 120 }}>
            <Select
              value={language}
              onChange={handleLanguageChange}
              variant="outlined"
              sx={{ 
                height: '35px',
                backgroundColor: '#f5f5f5',
                '& .MuiOutlinedInput-notchedOutline': {
                  border: 'none'
                }
              }}
            >
              <MenuItem value="en">English</MenuItem>
              <MenuItem value="es">Spanish</MenuItem>
            </Select>
          </FormControl> */}

          {/* Notifications */}
          <NotificationBell />

          {/* User Menu */}
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <IconButton
              onClick={handleMenu}
              sx={{
                borderRadius: 1,
                backgroundColor: '#f5f5f5',
                padding: '8px',
                '&:hover': {
                  backgroundColor: '#e0e0e0',
                },
              }}
            >
              <Typography variant="body2" sx={{ mr: 1, color: '#666' }}>
                {displayName || 'User'}
              </Typography>
              <AccountCircle />
              {/* <AccountCircle />  */}
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              <MenuItem
                onClick={() => {
                  handleClose();
                  setProfileOpen(true);
                }}
              >
                Profile
              </MenuItem>
              <MenuItem
                onClick={() => {
                  handleClose();
                  setPasswordOpen(true);
                }}
              >
                Change Password
              </MenuItem>
              <MenuItem
                onClick={() => {
                  handleClose();
                  handleLogout();
                }}
              >
                Logout
              </MenuItem>
            </Menu>
            <Dialog open={profileOpen} onClose={() => setProfileOpen(false)} maxWidth="md" fullWidth>
              <DialogContent>
                <EditProfileForm onClose={() => setProfileOpen(false)} />
              </DialogContent>
            </Dialog>
            <Dialog open={passwordOpen} onClose={() => setPasswordOpen(false)} maxWidth="sm" fullWidth>
              <DialogContent>
                <ChangePasswordForm onClose={() => setPasswordOpen(false)} />
              </DialogContent>
            </Dialog>
          </Box>
        </Box>
      </Toolbar>
      <SideBar open={drawerOpen} onClose={toggleDrawer(false)} />
    </AppBar>
  );
};

export default NavBar;
